import { I18nProvider } from '@dsx-react/i18n';
import { LinkSourceProvider } from '@dsx-react/link';
import { useContext, createContext } from 'react';
import { jsx, jsxs } from 'react/jsx-runtime';

const A11yContext = /*#__PURE__*/createContext(null);

/**
 * Implementation of DSX accessibility context provider.
 */
function A11yProvider(props) {
  const {
    children,
    portalTarget = typeof window !== 'undefined' ? document.body : null
  } = props;
  return /*#__PURE__*/jsx(A11yContext.Provider, {
    value: {
      portalTarget
    },
    children: children
  });
}

/**
 * Hook to retrieve the DSX accessibility context.
 */
function useA11y() {
  const ctx = useContext(A11yContext);
  if (ctx == null) {
    throw new Error('A <Provider /> component must be included at the root of your application.');
  }
  return ctx;
}

const ToastContext = /*#__PURE__*/createContext(false);

/**
 * react-toastify dependency provider
 */
function ToastProvider(props) {
  const {
    children,
    toastPortal: ToastPortal
  } = props;
  const hasToastPortal = !!ToastPortal;
  return /*#__PURE__*/jsxs(ToastContext.Provider, {
    value: hasToastPortal,
    children: [ToastPortal && /*#__PURE__*/jsx(ToastPortal, {}), children]
  });
}
function useHasToastPortal() {
  const hasToastPortal = useContext(ToastContext);
  return hasToastPortal;
}

/**
 * Implementation of DSX context provider.
 */
function Provider(props) {
  const {
    linkSources,
    locale,
    portalTarget,
    children,
    toastPortal
  } = props;
  return /*#__PURE__*/jsx(A11yProvider, {
    portalTarget: portalTarget,
    children: /*#__PURE__*/jsx(LinkSourceProvider, {
      linkSources: linkSources,
      children: /*#__PURE__*/jsx(I18nProvider, {
        locale: locale,
        children: /*#__PURE__*/jsx(ToastProvider, {
          toastPortal: toastPortal,
          children: children
        })
      })
    })
  });
}

export { A11yProvider, Provider, useA11y, useHasToastPortal };
